import type { Distance } from "@pdfking/math"

import type { FolderCorner, FolderShape } from "#internal"
import type { FolderDie } from "#public"

import { FolderChain } from "./FolderChain"
import { FolderOutline } from "./FolderOutline"
import { FolderSame } from "./FolderSame"

/** A die `width` x `height` of its parts, clockwise round its outline: the
 * outline cut round their corners, then their cuts and folds. */
export const FolderDieOf = (
  width: Distance,
  height: Distance,
  ...parts: (FolderShape | FolderCorner)[]
): FolderDie => {
  const { corners, cut, fold } = FolderChain(...parts)
  const closed = FolderSame(corners[0]!, corners[corners.length - 1]!)
    ? corners.slice(0, -1)
    : corners
  return { width, height, cut: [FolderOutline(closed), ...cut], fold }
}
